<template>
  <v-container fluid class="mt-5">
    <v-row class="mb-8">
      <v-col>
        <h2>Dashboard de Religação</h2>
      </v-col>
    </v-row>

    <v-card class="my-0 parametros-v-card" :disabled="loadingDados">
      <v-tabs v-model="tab" fixed-tabs color="primary">
        <v-tab>
          Visão Mensal
        </v-tab>
        <v-tab>
          Visão por Munícipios
        </v-tab>
      </v-tabs>
      <v-card-text>
        <v-card-title>
          <h4>Parâmetros</h4>
        </v-card-title>
        <div class="py-6">
          <v-row class="mx-1" align="center" justify="space-between">
            <v-col cols="12" md="auto">
              <v-row align="center">
                <v-col cols="12" md="auto" v-if="tab === 0">
                  <v-subheader class="px-0 grey--text">
                    Competência
                  </v-subheader>
                  <input-month
                    rules="min:7"
                    :minMonth="'2023-01'"
                    :selectedMonth="competencia"
                    @monthSelected="setCompetencia"
                    outlined
                    dense
                  />
                </v-col>
                <v-col v-if="tab === 1" cols="12" md="auto">
                  <v-subheader class="px-0 grey--text">
                    Competência de
                  </v-subheader>
                  <input-month
                    rules="min:7"
                    :minMonth="'2023-01'"
                    :selectedMonth="competenciaDe"
                    @monthSelected="setCompetenciaDe"
                    outlined
                    dense
                  />
                </v-col>
                <v-col
                  v-if="tab === 1"
                  cols="12"
                  md="auto"
                  class="d-flex align-center mt-11"
                >
                  <span class="font-weight-medium mx-3 grey--text body-2">
                    até
                  </span>
                  <input-month
                    rules="min:7"
                    :minMonth="'2023-01'"
                    :selectedMonth="competenciaAte"
                    @monthSelected="setCompetenciaAte"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="auto">
                  <v-subheader class="px-0 grey--text">
                    Regional
                  </v-subheader>
                  <v-select
                    :items="regionaisList"
                    :value="regionalSelecionada"
                    @change="setRegionalSelecionada"
                    hide-details
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="auto">
                  <v-subheader class="px-0 grey--text">
                    Serviços de Religação
                  </v-subheader>
                  <v-select
                    :items="listaServicosReligacao"
                    :value="servicosReligacaoSelecionados"
                    @change="setServicosReligacaoSelecionados"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    outlined
                    dense
                    hide-details
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip small v-if="index < 1">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span
                        v-if="index === servicosReligacaoSelecionados.length - 1"
                        class="grey--text text-caption ml-1"
                      >
                        (+{{ servicosReligacaoSelecionados.length - 1 }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="tab === 0"
              cols="12"
              md="auto"
              class="d-flex flex-column align-end mt-12"
            >
              <toggle-view
                :modelValue="visaoGraficos"
                :options="visaoGraficosOptions"
                :disabled="loadingDados"
                @update:modelValue="handleVisaoGraficosChange"
              />
            </v-col>
            <v-col
              v-if="tab === 1"
              cols="12"
              md="auto"
              class="d-flex justify-end align-end"
            >
              <div>
                <v-subheader class="px-0 grey--text">
                  Quantidade de Municípios
                </v-subheader>
                <v-select
                  :items="listaQuantidadeMunicipios"
                  :value="quantidadeMunicipios"
                  @change="setQuantidadeMunicipios"
                  outlined
                  dense
                  item-text="label"
                  item-value="value"
                  hide-details
                />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-progress-linear
        v-if="loadingDados"
        color="primary"
        indeterminate
        height="4"
        class="my-0"
      />
    </v-card>

    <v-tabs-items
      v-model="tab"
      style="background-color: transparent !important;"
    >
      <v-tab-item>
        <dashboard-religacao-visao-mensal
          :activatedTab="tab"
          :visaoGraficos="visaoGraficos"
          @updateLoadingDados="handleLoadingDados"
        />
      </v-tab-item>
      <v-tab-item>
        <dashboard-religacao-visao-municipios
          :activatedTab="tab"
          @updateLoadingDados="handleLoadingDados"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import Highcharts from "highcharts";
  import HighchartsNoData from "highcharts/modules/no-data-to-display";
  HighchartsNoData(Highcharts);
  import { mapActions, mapState } from "vuex";
  import MunicipiosService from "@/services/MunicipiosService";

  export default {
    name: "DashboardReligacao",
    components: {
      ToggleView: () => import("@/components/general/ToggleView.vue"),
      InputMonth: () => import("@/components/general/InputMonth.vue"),
      DashboardReligacaoVisaoMensal: () =>
        import(
          "@/components/dashboardReligacao/dashboardReligacaoVisaoMensal.vue"
        ),
      DashboardReligacaoVisaoMunicipios: () =>
        import(
          "@/components/dashboardReligacao/dashboardReligacaoVisaoMunicipios.vue"
        ),
    },
    data: () => ({
      tab: 0,
      loadingDados: false,
      listaQuantidadeMunicipios: [
        { label: "10 municípios", value: 10 },
        { label: "20 municípios", value: 20 },
        { label: "30 municípios", value: 30 },
        { label: "50 municípios", value: 50 },
        { label: "100 municípios", value: 100 },
        { label: "Todos", value: 0 },
      ],
      listaServicosReligacao: [
        {
          text:
            "61 - Restabelecer o fornecimento de energia elétrica em caso de suspensão indevida.",
          value: 61,
        },
        { text: "62 - Religação Urgência - Área Urbana", value: 62 },
        { text: "63 - Religação Urgência - Área Rural", value: 63 },
        { text: "64 - Religação Normal - Área Urbana", value: 64 },
        { text: "65 - Religação Normal - Área Rural", value: 65 },
      ],
      regionais: [],
      visaoGraficos: "mensais",
      visaoGraficosOptions: [
        { value: "mensais", text: "Dados Mensais" },
        { value: "acumulados", text: "Dados Acumulados" },
      ],
    }),
    computed: {
      ...mapState("parametrosDashboardReligacao", [
        "competencia",
        "competenciaDe",
        "competenciaAte",
        "regionalSelecionada",
        "quantidadeMunicipios",
        "servicosReligacaoSelecionados",
      ]),
      regionaisList() {
        return this.regionais.map((el) => ({
          text: el.nome,
          value: el.id,
        }));
      },
      regionalSelecionadaId() {
        return this.regionalSelecionada || 0;
      },
    },
    mounted() {
      this.setRangeCompetencias();
      this.getRegionais();
    },
    methods: {
      ...mapActions("parametrosDashboardReligacao", [
        "setCompetencia",
        "setCompetenciaDe",
        "setCompetenciaAte",
        "setRangeCompetencias",
        "setRegionalSelecionada",
        "setQuantidadeMunicipios",
        "setServicosReligacaoSelecionados",
      ]),

      getRegionais() {
        return MunicipiosService.getRegionais()
          .then((res) => {
            this.regionais = res;
            if (
              this.regionalSelecionada == null ||
              this.regionalSelecionada === 0
            ) {
              const distribuidora = res.find(
                (el) => el.nome.toLowerCase() == "distribuidora"
              );
              if (distribuidora) {
                this.setRegionalSelecionada(distribuidora.id);
              }
            }
          })
          .catch((err) => {
            console.error("Erro ao carregar regionais:", err);
          });
      },
      handleVisaoGraficosChange(value) {
        this.visaoGraficos = value;
      },
      handleLoadingDados(value) {
        this.loadingDados = value;
      },
    },
  };
</script>

<style>
.parametros-v-card {
  box-shadow: 0px 0px 0px !important;
}
.v-tab {
  text-transform: none !important;
}
</style>
